import { inject, Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { map, Observable } from 'rxjs';

@Pipe({
  name: 'secure',
  standalone: false,
})
export class SecurePipe implements PipeTransform {
  private httpClient = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);

  transform = (url): Observable<SafeUrl> => {
    return this.httpClient
      .get(url, {
        responseType: 'blob',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
      .pipe(
        map((val) => {
          return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(val));
        }),
      );
  };
}
